export default "__VITE_PUBLIC_ASSET__aa861fc9__"